import React from 'react';
import '../index.css';
import { useNavigate, useLocation } from 'react-router-dom';
import SavvytronFooter from '../components/SavvytronFooter'; // Adjust path if needed


const OrderConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderId = location.state?.orderId;  // get orderId safely

  return (
    <div className="min-h-dvh bg-candy-background px-4 py-10 sm:py-12">
      <div className="w-full max-w-xl mx-auto bg-white border border-candy-border rounded-2xl shadow-xl p-8 text-center">
        <h1 className="text-3xl sm:text-4xl font-bold text-candy-text font-hobo mb-4">
          🎉 Order Request Received!
        </h1>

        {/* Status message */}
        <div className="mt-4 mb-6 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded-lg text-left">
          <p className="font-semibold">⚠️ Your order is not yet confirmed.</p>
          <p className="mt-1 text-sm">
            It has been successfully submitted and is currently under review. You’ll receive a confirmation email once approved by our team.
          </p>
        </div>

        {/* Show Order ID */}
        {orderId && (
          <div className="mb-6">
            <p className="text-lg font-semibold text-candy-primary">
              Your Order ID:
            </p>
            <div className="text-2xl font-bold text-candy-primary mt-2">
              {orderId}
            </div>
          </div>
        )}

        <p className="text-gray-700 text-base sm:text-lg">
          Thank you for placing your cake order request. Our team is now reviewing your details.
        </p>

        <p className="text-gray-600 text-sm mt-2">
          📩 We’ll keep you updated via email or text message.
        </p>

        <button
          onClick={() => navigate('/')}
          className="mt-8 inline-flex items-center justify-center gap-2 bg-candy-primary text-white px-6 py-2.5 rounded-full text-sm sm:text-base font-semibold shadow-md hover:bg-candy-primary/90 transition-all duration-200"
        >
          ← Home
        </button>

              <SavvytronFooter className="mt-10" />

      </div>

    </div>
  );
};

export default OrderConfirmation;
